import React from 'react';
import { SingleCommonType } from '../../types';
import { earlyAccessPlaceholder } from '../../constants/placeholder';
import CommonSingleSelect from '../../components/CommonSingleSelect';
import { refundedOptions } from '../../constants/refunded';
import './index.scss';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function EarlyAccessSelect(props: SingleCommonType) {
  return (
    <div className="early-access-select-wrapper">
      <CommonSingleSelect
        {...props}
        returnKey="early_access"
        dealwithReturnValue={(value) => Number(value)}
        singlePlaceholder={earlyAccessPlaceholder}
        options={refundedOptions}
        pointKey={FilterButtonPoint.earlyAccess}
        initValue="0"
      />
    </div>
  );
}
